import { type TranslationTree } from '@/i18n/types';

export const messages = {
  claimTitle: 'Assuma a conta de {{partner}}',
  memberTitle: 'Entre na equipe de {{partner}}',
  role: {
    owner:
      'A equipe Bodyprint cadastrou a conta. Ao aceitar, você passa a ser o responsável por ela no portal de parceiros.',
    editor: 'Com acesso de edição: cria e edita eventos e ofertas da conta.',
    viewer: 'Com acesso de leitura: acompanha eventos, ofertas e resultados da conta.',
  },
  invitedEmail: 'Convite para',
  expires: 'Vale até {{date}}',
} satisfies TranslationTree;
